
import { FileText } from 'lucide-react';
import { DocumentAnalysisStatus } from './DocumentAnalysisStatus';

interface UploadedDocument {
  id: string;
  name: string;
  uploadedAt: string;
  relevanceScore?: number;
  isAnalyzing?: boolean;
}

interface UploadedDocumentItemProps {
  document: UploadedDocument;
  onViewAssessment: (doc: UploadedDocument) => void;
}

export const UploadedDocumentItem = ({ document, onViewAssessment }: UploadedDocumentItemProps) => {
  return (
    <div className="p-3 bg-muted/50 rounded border">
      <div className="flex items-center gap-2 mb-1">
        <FileText className="h-4 w-4 text-primary" />
        <span className="flex-1 text-sm font-medium">{document.name}</span>
        <span className="text-xs text-muted-foreground">
          {new Date(document.uploadedAt).toLocaleDateString()}
        </span>
      </div>
      <DocumentAnalysisStatus
        isAnalyzing={document.isAnalyzing}
        relevanceScore={document.relevanceScore}
        onViewAssessment={() => onViewAssessment(document)}
      />
    </div>
  );
};
